module.exports = __webpack_public_path__ + "media/images/icons/favicon-85a77235dda07d1b2c5f20e3a35b82ce.svg";